// Date-range helpers for the Admin dashboard filter.
// All ranges are computed in the browser's local timezone but sent to the
// backend as ISO-8601 strings (UTC-aware via toISOString()).

export const DATE_PRESETS = [
  { value: 'all', label: 'Bütün tarixlər' },
  { value: 'today', label: 'Bu gün' },
  { value: 'yesterday', label: 'Dünən' },
  { value: 'week', label: 'Bu həftə' },
  { value: 'month', label: 'Bu ay' },
  { value: 'custom', label: 'Xüsusi tarix aralığı' },
];

// Build [from, to] Date objects for a given preset. Returns { from, to } or null.
export const getPresetRange = (preset) => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const endOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);

  switch (preset) {
    case 'today':
      return { from: startOfToday, to: endOfToday };
    case 'yesterday': {
      const from = new Date(startOfToday);
      from.setDate(from.getDate() - 1);
      const to = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 23, 59, 59, 999);
      return { from, to };
    }
    case 'week': {
      // Monday = start of the week (ISO-style)
      const from = new Date(startOfToday);
      const day = from.getDay(); // 0=Sun..6=Sat
      const diffToMonday = (day + 6) % 7;
      from.setDate(from.getDate() - diffToMonday);
      return { from, to: endOfToday };
    }
    case 'month': {
      const from = new Date(now.getFullYear(), now.getMonth(), 1);
      return { from, to: endOfToday };
    }
    default:
      return null;
  }
};

// Convert a local YYYY-MM-DD date string (from <input type="date">) into a
// Date at start-of-day (from) or end-of-day (to) in local time.
export const parseLocalDate = (value, endOfDay = false) => {
  if (!value) return null;
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return null;
  return endOfDay
    ? new Date(y, m - 1, d, 23, 59, 59, 999)
    : new Date(y, m - 1, d, 0, 0, 0, 0);
};

// Format a Date as YYYY-MM-DD for <input type="date"> value binding.
export const toDateInputValue = (date) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
